import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop ordering for admin index rows. Sends the new id order to the
// server on drop, then refreshes the page so positions render.
export default class extends Controller {
  static values = {
    url: String,
    handle: { type: String, default: ".drag-handle" }
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      animation: 150,
      handle: this.handleValue,
      ghostClass: "sortable-ghost",
      chosenClass: "sortable-chosen",
      onEnd: (event) => this.save(event)
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  save(event) {
    // Dropping an item back into its original slot still re-sends the order;
    // the server write is idempotent and the refresh is cheap.
    const ids = Array.from(this.element.querySelectorAll("tr[data-id]"))
      .map((row) => row.dataset.id)

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ kind: event.item.dataset.kind, order: ids })
    }).then((response) => {
      if (!response.ok) throw new Error("Sort failed")
      if (window.Turbo) {
        window.Turbo.visit(window.location.href, { action: "replace" })
      } else {
        window.location.reload()
      }
    }).catch(() => {
      // Put the list back the way it was if the save failed.
      window.Turbo ? window.Turbo.visit(window.location.href) : window.location.reload()
    })
  }
}
